import React from "react";
import HeroSection from "../sections/HeroSection";
import IntroducingSection from "../sections/IntroducingSection";
import KeyFeaturesSection from "../sections/KeyFeaturesSection";
import SubFeaturesSection from "../sections/SubFeaturesSection";
import VideoSection from "../sections/VideoSection";
import GodsSection from "../sections/GodsSection";
import RoadMapSection from "../sections/RoadMapSection";
import { MainContainer, SectionWrapper } from "../styles/pages/MainStyles";

const Main = () => {
  return (
    <MainContainer>
      <HeroSection />
      <IntroducingSection />
      <KeyFeaturesSection />
      <SubFeaturesSection />
      <VideoSection />
      <GodsSection />
      <RoadMapSection />
    </MainContainer>
  );
};

export default Main;
